const CALLBACK_NAME = "__gestionaloGoogleMapsCb";

declare global {
  interface Window {
    [CALLBACK_NAME]?: () => void;
    google?: typeof google;
  }
}

let loadPromise: Promise<void> | null = null;

export function loadGoogleMapsScript(apiKey: string): Promise<void> {
  if (typeof window === "undefined") {
    return Promise.reject(new Error("Google Maps can only load in the browser"));
  }
  if (window.google?.maps?.places) {
    return Promise.resolve();
  }
  if (loadPromise) {
    return loadPromise;
  }
  loadPromise = new Promise((resolve, reject) => {
    const existing = document.querySelector<HTMLScriptElement>('script[data-gestionalo-gmaps="1"]');
    const finishOk = (): void => {
      resolve();
    };
    if (existing) {
      if (window.google?.maps?.places) {
        finishOk();
        return;
      }
      existing.addEventListener("load", finishOk, { once: true });
      existing.addEventListener(
        "error",
        () => {
          loadPromise = null;
          reject(new Error("Google Maps failed to load"));
        },
        { once: true },
      );
      return;
    }

    window[CALLBACK_NAME] = () => finishOk();

    const script = document.createElement("script");
    const params = new URLSearchParams({
      key: apiKey,
      libraries: "places",
      callback: CALLBACK_NAME,
      /** https://developers.google.com/maps/documentation/javascript/load-maps-js-api */
      loading: "async",
    });
    script.src = `https://maps.googleapis.com/maps/api/js?${params.toString()}`;
    script.async = true;
    script.dataset.gestionaloGmaps = "1";
    script.onerror = () => {
      loadPromise = null;
      reject(new Error("Google Maps failed to load"));
    };
    document.head.appendChild(script);
  });
  return loadPromise;
}
